import React, { useEffect } from "react";
import useFetcher from "../../hooks/useFetcher";
import SelectV2 from "../SelectV2";
import { fetchTreeMotivo } from "../../services/motivoServices";
import { fetchTicketingCategories } from "../../services/ticketingServices";
import { fetchSucursales } from "../../services/sucursalServices";
import { retriveMotivoData } from "./retriveMotivoData";
import { retriveSubmotivoData } from "./retriveSubmotivoData";
import { retriveSucursalDeptoData } from "./retriveSucursalDeptoData";
import { CustomLabel, ErrorFeedback } from "../../ui/labels";

const TicketZoneSelector = ({ formik, typeMotivo, mounted = null, setDisclaimer, grid = false }) => {
  const [ticketingCategories, isLoadingTicketingCategories] = useFetcher(fetchTicketingCategories);
  const [motivosConfig, isLoadingMotivos] = useFetcher(fetchTreeMotivo);
  const [sucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");

  // se filtran por motivos activos
  const motivosActivos = motivosConfig.filter((motivo) => motivo.estado !== 2);

  // se filtran por submotivos activos
  const motivosAndSubmotivosActivos = motivosActivos.map((motivo) => {
    const newMotivo = motivo;
    newMotivo.Submotivos = motivo.Submotivos.filter((submotivo) => submotivo.estado !== 2);
    return newMotivo;
  });

  // se busca dentro del submotivo seleccionado el disclaimer
  if (setDisclaimer) {
    const searchDisclaimer = () => {
      const selectedMotivo = motivosConfig
        ? motivosConfig.find((motivo) => {
            return motivo.itemId === formik.values.motivo;
          })
        : null;
      const subMotivos = selectedMotivo ? selectedMotivo.Submotivos : null;
      const selectedSubmotivo = subMotivos
        ? subMotivos.find((submotivo) => {
            return submotivo.itemId === formik.values.submotivo;
          })
        : null;

      const disclaimer = selectedSubmotivo ? selectedSubmotivo.disclaimer : "";

      setDisclaimer(disclaimer);
      return true;
    };

    // solo busca el disclaimer cuando el submotivo cambia
    useEffect(() => {
      searchDisclaimer();
    }, [formik.values.submotivo]);
  }

  if (isLoadingMotivos || isLoadingTicketingCategories) {
    return null;
  }

  if (motivosAndSubmotivosActivos && mounted) {
    mounted();
  }

  const asignacion2Options = ticketingCategories["asignacion-2"]
    ? ticketingCategories["asignacion-2"]
        .map((asignacion) => {
          return { label: asignacion.text, value: asignacion.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  let asignacion2Value = asignacion2Options.find((option) => {
    return option.value === formik.values.asignacion2;
  });
  asignacion2Value = asignacion2Value || null;

  // eslint-disable-next-line prettier/prettier
  const [
    sucursaldepartamentoAsignadoOptions,
    sucursaldepartamentoAsignadoLabel,
    sucursaldepartamentoAsignadoPlaceholder,
    // eslint-disable-next-line prettier/prettier
    sucursaldepartamentoAsignadoValue,
  ] = retriveSucursalDeptoData(motivosAndSubmotivosActivos, formik);

  // se filtran por sucursales activas para mostrarlas como
  // opcion cuando se requiere asignar una sucursal y no un departamento
  const sucursalesAvtivas = sucursales.filter((sucursal) => sucursal.estado !== 2);
  const sucursalesActivasIds = sucursalesAvtivas.map((sucursal) => sucursal.itemId);
  const sucursalesActivasOptions = sucursaldepartamentoAsignadoOptions.filter((option) => {
    return sucursalesActivasIds.includes(option.value);
  });
  //--------------------------------------------------------

  const [motivoOptions, motivoPlaceholder, motivoValue] = retriveMotivoData(motivosAndSubmotivosActivos, formik);
  const [submotivoOptions, submotivoPlaceholder, submotivoValue] = retriveSubmotivoData(motivosAndSubmotivosActivos, formik);
  return (
    <div style={grid ? { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", justifyItems: "stretch", alignItems: "start", gap: "1rem" } : {}}>
      {typeMotivo ? (
        <>
          <div>
            <CustomLabel htmlFor="motivo" className="w-100" fontSize="18px" fontWeight="800">
              Motivo
            </CustomLabel>
            <SelectV2
              height="40px"
              id="motivo"
              name="motivo"
              className={`w-100 ${formik.errors.motivo && formik.touched.motivo ? "error-field" : ""}`}
              formik={formik}
              value={motivoValue}
              placeholder={motivoPlaceholder}
              isClearable
              isLoading={isLoadingMotivos}
              disabled={formik.isSubmitting || isLoadingMotivos}
              options={motivoOptions}
            />
            {formik.errors.motivo && formik.touched.motivo && <ErrorFeedback>{formik.errors.motivo}</ErrorFeedback>}
          </div>
          <div>
            <CustomLabel htmlFor="submotivo" className="w-100" fontSize="18px" fontWeight="800">
              Submotivo
            </CustomLabel>
            <SelectV2
              height="40px"
              id="submotivo"
              name="submotivo"
              className={`w-100 ${formik.errors.submotivo && formik.touched.submotivo ? "error-field" : ""}`}
              formik={formik}
              value={submotivoValue}
              placeholder={submotivoPlaceholder}
              isClearable
              isLoading={isLoadingMotivos}
              disabled={formik.isSubmitting || isLoadingMotivos}
              options={submotivoOptions}
            />
            {formik.errors.submotivo && formik.touched.submotivo && <ErrorFeedback>{formik.errors.submotivo}</ErrorFeedback>}
          </div>
        </>
      ) : (
        <>
          <div>
            <CustomLabel htmlFor="asignacion2" className="w-100" fontSize="18px" fontWeight="800">
              Sector
            </CustomLabel>
            <SelectV2
              height="40px"
              className={`w-100 ${formik.errors.asignacion2 && formik.touched.asignacion2 ? "error-field" : ""}`}
              id="asignacion2"
              name="asignacion2"
              formik={formik}
              disabled={formik.isSubmitting || isLoadingTicketingCategories}
              value={asignacion2Value}
              placeholder="Seleccione el sector"
              isClearable
              isLoading={isLoadingTicketingCategories}
              options={asignacion2Options}
            />
            {formik.errors.asignacion2 && formik.touched.asignacion2 && <ErrorFeedback>{formik.errors.asignacion2}</ErrorFeedback>}
          </div>
          <div>
            <CustomLabel htmlFor="sucursaldepartamentoAsignado" className="w-100" fontSize="18px" fontWeight="800">
              {sucursaldepartamentoAsignadoLabel}
            </CustomLabel>
            <SelectV2
              height="40px"
              id="sucursaldepartamentoAsignado"
              name="sucursaldepartamentoAsignado"
              className={`w-100 ${formik.errors.sucursaldepartamentoAsignado && formik.touched.sucursaldepartamentoAsignado ? "error-field" : ""}`}
              formik={formik}
              value={sucursaldepartamentoAsignadoValue}
              placeholder={sucursaldepartamentoAsignadoPlaceholder}
              isClearable
              isLoading={isLoadingMotivos}
              disabled={formik.isSubmitting || isLoadingMotivos}
              options={sucursaldepartamentoAsignadoLabel === "Sucursal" ? sucursalesActivasOptions : sucursaldepartamentoAsignadoOptions}
            />
            {formik.errors.sucursaldepartamentoAsignado && formik.touched.sucursaldepartamentoAsignado && (
              <ErrorFeedback>{formik.errors.sucursaldepartamentoAsignado}</ErrorFeedback>
            )}
          </div>
          <div>
            <CustomLabel htmlFor="motivo" className="w-100" fontSize="18px" fontWeight="800">
              Motivo
            </CustomLabel>
            <SelectV2
              height="40px"
              id="motivo"
              name="motivo"
              className={`w-100 ${formik.errors.motivo && formik.touched.motivo ? "error-field" : ""}`}
              formik={formik}
              value={motivoValue}
              placeholder={motivoPlaceholder}
              isClearable
              isLoading={isLoadingMotivos}
              disabled={formik.isSubmitting || isLoadingMotivos}
              options={motivoOptions}
            />
            {formik.errors.motivo && formik.touched.motivo && <ErrorFeedback>{formik.errors.motivo}</ErrorFeedback>}
          </div>
          <div>
            <CustomLabel htmlFor="submotivo" className="w-100" fontSize="18px" fontWeight="800">
              Submotivo
            </CustomLabel>
            <SelectV2
              height="40px"
              id="submotivo"
              name="submotivo"
              className={`w-100 ${formik.errors.submotivo && formik.touched.submotivo ? "error-field" : ""}`}
              formik={formik}
              value={submotivoValue}
              placeholder={submotivoPlaceholder}
              isClearable
              isLoading={isLoadingMotivos}
              disabled={formik.isSubmitting || isLoadingMotivos}
              options={submotivoOptions}
            />
            {formik.errors.submotivo && formik.touched.submotivo && <ErrorFeedback>{formik.errors.submotivo}</ErrorFeedback>}
          </div>
        </>
      )}
    </div>
  );
};

export default TicketZoneSelector;
